import React, { useContext } from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole, renderGroupComponent } from "../../util/FormUtils";

const DateSelector = ({ category, label, date, approvalDate, handleChange, pullLists, allowedRoles = [], tag, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal, required }) => {
    const { user } = useContext(UserContext);
    const canEdit =
        (shipmentFromRepo === "No" && sampleDisposal === "No") || (
            informedConsent !== "No" &&
            informedConsentApprover !== "No" &&
            checkRole(user, allowedRoles) &&
            (category !== "shipDate" || approvalDate)
        )

    return (
        <div className="planField">
            {renderGroupComponent(tag ? tag : allowedRoles[0])}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    id={`${category}-field`}
                    name={`${category}`}
                    label={label ? pullListLabels[label] : pullListLabels[category]}
                    required={required}
                    views={["year", "month", "day"]}
                    value={date ? dayjs(date) : null}
                    onChange={(date) => handleChange(category, date.format("YYYY-MM-DD"))}
                    slotProps={{
                        textField: {
                            InputLabelProps: { shrink: true },
                            required: required,
                        }
                    }}
                    disabled={!canEdit}
                />
            </LocalizationProvider>
            <HistoryLogElement pullLists={pullLists} label={category} />
        </div>
    );
};

export default DateSelector;